/**
 * Маппинг сообщений об ошибках API с английского на русский для отображения пользователю.
 * Добавляйте сюда новые строки по мере обнаружения английских сообщений на экранах.
 */
const API_ERROR_TRANSLATIONS = {
  // Auth / логин
  'Invalid credentials': 'Неверный логин или пароль',
  'Invalid JSON data': 'Некорректные данные запроса',
  'Login and password are required': 'Введите логин и пароль',
  'User already exists': 'Пользователь с таким логином уже существует',
  'Registration failed': 'Ошибка регистрации',
  'Invalid token': 'Недействительная сессия. Войдите снова',
  'Invalid token format': 'Неверный формат сессии',
  'No token provided': 'Требуется вход в систему',
  'Token expired': 'Сессия истекла. Войдите снова',

  // Admin / пользователи и права
  'Login is required': 'Укажите логин',
  'Password is required': 'Укажите пароль',
  'User with this login already exists': 'Пользователь с таким логином уже существует',
  'Department IDs are required for department_head role': 'Для роли руководителя подразделения укажите подразделения',
  'User not found': 'Пользователь не найден',
  'Cannot delete yourself': 'Нельзя удалить свою учётную запись',
  'Failed to get users': 'Не удалось загрузить список пользователей',
  'Failed to create user': 'Не удалось создать пользователя',
  'Failed to update user': 'Не удалось обновить пользователя',
  'Failed to delete user': 'Не удалось удалить пользователя',
  'Failed to get employees': 'Не удалось загрузить сотрудников',
  'Failed to get roles': 'Не удалось загрузить роли',
  'Failed to update permissions': 'Не удалось сохранить права',
  'Permissions data is required': 'Укажите данные прав',
  'Invalid role code': 'Некорректный код роли',
  'No fields to update': 'Нет данных для обновления',

  // Справочники и настройки
  'Failed to get sync settings': 'Не удалось загрузить настройки синхронизации',
  'Failed to get reference values': 'Не удалось загрузить справочник',
  'Failed to synchronize reference values': 'Ошибка синхронизации справочника',
  'Value not found': 'Значение не найдено',
  'Reference not found': 'Справочник не найден',
  'Invalid entity type': 'Некорректный тип сущности',
  'Failed to get deleted records': 'Не удалось загрузить удалённые записи',
  'Failed to restore record': 'Не удалось восстановить запись',
  'Failed to delete record': 'Не удалось удалить запись',
  'Invalid request data': 'Некорректные данные запроса',
  'Sync interval must be at least 60 seconds': 'Интервал синхронизации не менее 60 секунд',
  'Sync interval must be at most 86400 seconds (24 hours)': 'Интервал синхронизации не более 24 часов',
  'Invalid sync interval value': 'Некорректный интервал синхронизации',
  'Settings updated successfully': 'Настройки сохранены',
  'Failed to get custom field definitions': 'Не удалось загрузить настройки полей',
  'Failed to create custom field definition': 'Не удалось создать поле',
  'Failed to update custom field definition': 'Не удалось обновить поле',
  'Failed to get custom team percentages': 'Не удалось загрузить проценты команды',
  'Failed to get gip rules': 'Не удалось загрузить правила ГИП',
  'Failed to get budget rules': 'Не удалось загрузить правила бюджета',
  'Failed to get budget employees': 'Не удалось загрузить сотрудников бюджета',
  'Definition not found': 'Определение не найдено',
  'Option not found': 'Вариант не найден',

  // Подразделения / доходы
  'Department not found': 'Подразделение не найдено',
  'team.name_already_exists': 'Команда с таким названием уже существует. Одна команда может относиться только к одному подразделению.',
  'Failed to get department planned income': 'Не удалось загрузить плановые доходы подразделения',
  'Failed to get department actual income': 'Не удалось загрузить фактические доходы подразделения',

  // Стадии
  'Failed to create stage': 'Не удалось создать стадию',
  'Failed to update stage': 'Не удалось обновить стадию',
  'Failed to delete stage': 'Не удалось удалить стадию',
  'Contract not found': 'Договор не найден',
  'distribution_type is required': 'Укажите тип распределения',
  'type (or name) or distribution_type is required': 'Укажите тип распределения',
  'custom_data must be an object': 'Некорректный формат пользовательских данных',

  // Объекты
  'Failed to create object': 'Не удалось создать объект',
  'Failed to update object': 'Не удалось обновить объект',
  'Failed to delete object': 'Не удалось удалить объект',
  'Failed to get object': 'Не удалось загрузить объект',
  'Failed to get objects': 'Не удалось загрузить объекты',
  'Failed to get object types': 'Не удалось загрузить типы объектов',
  'Object not found': 'Объект не найден',
  'living_area is required': 'Укажите площадь',
  'parking_spaces is required': 'Укажите количество машиномест',
  'client_id is required': 'Укажите клиента',

  // Общие / HTTP
  'Forbidden': 'Доступ запрещён. Недостаточно прав.',
  'Unauthorized': 'Требуется вход в систему',
  'name is required': 'Укажите название',
  'value is required': 'Укажите значение',
  'team.sub_teams_incomplete': 'Если у одного участника задана подкоманда, её нужно указать для всех участников команды',
}

/**
 * Возвращает русский текст ошибки для отображения пользователю.
 * @param {string} message — текст от API или exception message
 * @returns {string}
 */
export function translateApiError(message) {
  if (!message || typeof message !== 'string') return message
  const trimmed = message.trim()
  const lower = trimmed.toLowerCase()
  if (
    lower.includes('budget_rules_team_distribution_type_key') ||
    (lower.includes('duplicate key value violates unique constraint') && lower.includes('budget_rules'))
  ) {
    return 'Такое правило уже существует для этого типа распределения. Удалите дубликат строки.'
  }
  return API_ERROR_TRANSLATIONS[trimmed] || trimmed
}
